'use strict';

var app = angular.module('postCenterWebClientApp');

app.filter('i18nYesNo', function($filter){
  return function(boolean){
    var translate = $filter('translate');
    return boolean? translate('YES') : translate('NO');
  };
});